
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"86","height":"96","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d)"}},[_c('path',{attrs:{"d":"M43.34 5.167l33.487 19.334v38.666L43.34 82.5 9.855 63.167V24.5L43.34 5.167z","fill":"#0067AD"}}),_c('path',{attrs:{"d":"M9.854 63.167L43.34 82.5V5.167L9.855 24.501v38.666z","fill":"#007EC1"}}),_c('path',{attrs:{"fill":"#007EC1","d":"M30.421 32.898h27.027v21.659H30.421z"}}),_c('path',{attrs:{"d":"M43.34 25.28a18.553 18.553 0 100 37.106 18.553 18.553 0 000-37.105zm11.724 14.125L42.592 51.877a4.026 4.026 0 01-5.707 0l-5.267-5.28a2.814 2.814 0 013.976-3.964l4.145 4.144 11.348-11.361a2.815 2.815 0 014.592.92 2.817 2.817 0 01-.615 3.07z","fill":"#fff"}})]),_c('defs',[_c('filter',{attrs:{"id":"filter0_d","x":".854","y":".167","width":"84.972","height":"95.333","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"}}),_c('feOffset',{attrs:{"dy":"4"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"4.5"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow","result":"shape"}})])])])
          )
        }
      }
    